import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react'
import Prompt from 'components/Prompt/Prompt.js';
import AdditionalResource from 'components/AdditionalResource/AdditionalResource.js';

import './PromptSet.sass'

class PromptSet extends Component {
	render() {
		return (
			<Segment raised className="promptSet">
				<h3>{this.props.title}</h3>
				{ this.props.prompts &&
					this.props.prompts.map((el, idx) =>
						<Prompt key={idx} index={idx + 1} value={el} />
					)
				}
				{ this.props.resources &&
					this.props.resources.map((el, idx) =>
						<AdditionalResource key={idx} url={el.url} text={el.text} />
					)
				}
			</Segment>
		);
	}
}

export default PromptSet;
